import styled from 'styled-components';

interface SwatchProps {
  color: string;
  dashed?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 8px 8px 0;
`;

export const Caption = styled.span`
  padding: 0 4px;
  font-size: 12px;
  color: #9e9e9e;
`;

export const Empty = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  font-size: 13px;
  color: #9e9e9e;
`;

export const Legend = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  padding: 0 4px 10px;
  list-style: none;
`;

export const LegendItem = styled.li`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #6d6d78;
`;

export const Swatch = styled.span<SwatchProps>`
  display: inline-block;
  width: 18px;
  border-top: 2px ${({ dashed }) => (dashed ? 'dashed' : 'solid')}
    ${({ color }) => color};
`;

export const Loading = styled(Empty)`
  min-height: 324px;
`;
